import React from 'react'
import { v4 as uuidv4 } from 'uuid'

const AlertIcon = () => {
  const id = uuidv4()
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 105H115L60 10L5 105ZM65 90H55V80H65V90ZM65 70H55V50H65V70Z"
        fill="#515356"
      />
      <mask
        id={`mask0_${id}`}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="10"
        width="110"
        height="95">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 105H115L60 10L5 105ZM65 90H55V80H65V90ZM65 70H55V50H65V70Z"
          fill="white"
        />
      </mask>
      <g mask={`url(#mask0_${id})`}>
        <rect width="120" height="120" fill="#515356" />
      </g>
    </svg>
  )
}

export default AlertIcon
